import React, { forwardRef, MouseEvent, useMemo } from 'react';
import {
    Selection as SelectionModel,
    SelectionMovie,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { Route, RouterLocation } from '@funtech-int/rival';
import classnames from 'classnames';

import { Carousel } from '../Carousel/Carousel';
import * as Card from '../Card';

import { SelectionTitle } from './_SelectionTitle';
import styles from './_Selection.module.css';

interface SelectionProps {
    selection: SelectionModel;
    location?: RouterLocation<any, any>;
    movieRoute: Route<any, { id: string }, any>;
    className?: string;
    onHeaderClick?(): void;
    onShowAllClick?(): void;
    onCardShow?(item: SelectionMovie, index: number): void;
    onCardClick?(item: SelectionMovie, index: number): void;
}

export const Selection = forwardRef<HTMLDivElement, SelectionProps>(
    (
        {
            selection,
            location,
            movieRoute,
            className,
            onHeaderClick,
            onShowAllClick,
            onCardShow,
            onCardClick,
        },
        ref
    ) => {
        const searchParams = useMemo(() => new URLSearchParams(), []);

        if (selection.showcaseId) {
            searchParams.set('selectionWindowId', selection.showcaseId);
        }

        return (
            <div ref={ref} className={classnames(styles.root, className)} data-tid="Selection">
                <SelectionTitle
                    title={selection.title}
                    subtitle={selection.comment}
                    location={location}
                    searchParams={searchParams}
                    onClick={onHeaderClick}
                    iconClassName={styles.titleLinkIcon}
                />
                <Carousel>
                    {selection.items.map((item, index) => {
                        const handleCardShow = () => {
                            onCardShow?.(item, index);
                        };

                        const handleCardClick = (e: MouseEvent<HTMLAnchorElement>) => {
                            e.preventDefault();
                            onCardClick?.(item, index);
                        };

                        return (
                            <Card.Movie
                                key={item.contentId}
                                movie={item}
                                location={movieRoute({ id: item.contentId })}
                                onShow={handleCardShow}
                                onClick={handleCardClick}
                                withPlannedToWatch
                            />
                        );
                    })}
                    {selection.hasMore && location && (
                        <Card.ShowAll
                            location={location}
                            searchParams={searchParams}
                            onClick={onShowAllClick}
                        />
                    )}
                </Carousel>
            </div>
        );
    }
);
